import { useContext } from "react";

import GlobalContext                from "../contexto/GlobalContext";

import * as TipoDeError from "../servicios/Errores";
import CodigoDeError from "./CodigosDeErrorDeRespuestas.json";
import DataDeRespuestas_Comun from "./DataEstaticaDeRespuestas.json";
import { NotificacionToastDeError } from "./widgets/Notificaciones";

const useHandlerDeComando = (funcionQueLanzaElServicio) => {
    const { notificar } = useContext(GlobalContext);

    return async (input) => {
        try {
            await funcionQueLanzaElServicio(input);
        } catch (error) {
            if( error instanceof TipoDeError.ErrorCancelacion){return;}
            if (error instanceof TipoDeError.ErrorTecnico) {
                let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                );
                return;
            }
        }
    };
};

export default useHandlerDeComando;
